(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/dialog.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/dialog.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


(function (svs, TweenLite) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  svs.components.dialog.Dialog = function () {
    function Dialog(options) {
      _classCallCheck(this, Dialog);

      this.options = options;
      this.log = new svs.core.log.Logger('Dialog');
    }

    _createClass(Dialog, [{
      key: "createWrapper",
      value: function createWrapper() {
        this.el = document.createElement('div');
        this.el.className += 'js-dialog dialog';
      }
    }, {
      key: "createQueue",
      value: function createQueue() {
        this.queue = new svs.components.dialog.DialogQueue({
          attachTo: this.el
        });
      }
    }, {
      key: "render",
      value: function render() {
        this.el = document.querySelector('.js-dialog');

        if (this.el) {
          this.log.debug('No more dialog containers needed.');
        } else {
          this.createWrapper(); 

          document.body.appendChild(this.el);
        }

        this.createQueue();
        this.addEventListeners();
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this = this;

        this.queue.on('changed', this, function (dialog) {
          _this.updateClickEvents(dialog);
        });
        this.queue.on('added', this, function (dialog) {
          _this.updateClickEvents(dialog);
        });
        this.queue.on('showDimmer', this, function () {
          _this.showDimmer();
        });
        this.queue.on('hideDimmer', this, function () {
          _this.hideDimmer();
        });
      }
    }, {
      key: "showDimmer",
      value: function showDimmer() {
        var _this2 = this;

        if (!this.isDimmed) {
          TweenLite.to(this.el, 0.2, {
            backgroundColor: 'rgba(0, 0, 0, .4)',
            onComplete: function onComplete() {
              if (_this2.el) {
                _this2.el.classList.add('dialog-dimmed');
              }
            }
          });
          this.isDimmed = true;
        }
      }
    }, {
      key: "hideDimmer",
      value: function hideDimmer() {
        var _this3 = this;

        var popupCount = this.queue && this.queue.areas && this.queue.areas[svs.components.dialog.area.POPUP] && this.queue.areas[svs.components.dialog.area.POPUP].count();
        var toasterCount = this.queue && this.queue.areas && this.queue.areas[svs.components.dialog.area.TOASTER] && this.queue.areas[svs.components.dialog.area.TOASTER].count();

        if (this.queue && !this.queue.count()) {
          if (this.isDimmed) {
            TweenLite.to(this.el, 0.1, {
              backgroundColor: 'rgba(0,0,0,0)',
              onComplete: function onComplete() {
                if (!_this3.queue.count()) {
                  _this3.remove();
                }
              }
            });
          } else {
            this.remove();
          }

          this.isDimmed = false;
        } else if (popupCount === 0 && toasterCount > 0) {
          if (this.isDimmed) {
            TweenLite.to(this.el, 0.1, {
              backgroundColor: 'rgba(0,0,0,0)',
              onComplete: function onComplete() {
                if (_this3.el) {
                  _this3.el.classList.remove('dialog-dimmed');
                }
              }
            });
          }

          this.isDimmed = false;
        }
      }
    }, {
      key: "updateClickEvents",
      value: function updateClickEvents(dialog) {
        if (dialog && dialog.allowDimmerClick) {
          this.addClickEvents();
        } else {
          this.removeClickEvents();
        }
      }
    }, {
      key: "addClickEvents",
      value: function addClickEvents() {
        var _this4 = this;

        this.el.classList.add('dialog-close-outside-click');

        this.el.onclick = function (e) {
          if (e.target === _this4.el) {
            _this4.queue.closeFromOutside();

            _this4.removeClickEvents();
          }
        };
      }
    }, {
      key: "remove",
      value: function remove() {
        this.removeClickEvents();

        if (this.el) {
          document.body.removeChild(this.el);
          this.el = null;
        }
      }
    }, {
      key: "removeClickEvents",
      value: function removeClickEvents() {
        if (this.el) {
          this.el.classList.remove('dialog-close-outside-click');
          this.el.onclick = null;
        }
      }
    }, {
      key: "add",
      value: function add(dialog) {
        if (!this.el) {
          this.render();
        }

        this.queue.add(dialog);
      }
    }, {
      key: "close",
      value: function close() {
        this.queue && this.queue.closeFromOutside();
      }
    }]);

    return Dialog;
  }();
})(svs, TweenLite);
 })(window);